import { render, staticRenderFns } from "./CourseContent.vue?vue&type=template&id=3875535a&"
import script from "./courseContent.js?vue&type=script&lang=js&"
export * from "./courseContent.js?vue&type=script&lang=js&"
import style0 from "./courseContent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports